
import { getSponsors,deleteSponsor,updateSponsor,Sreset } from "../../features/users/sponsors/sponsorsSlice";
// import './Delegates.css'
import { DataGrid } from '@mui/x-data-grid';
import {useSelector,useDispatch} from "react-redux";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import { useState,useEffect } from "react";
import {togglebars} from "../../features/bars/bars"
import {Link} from "react-router-dom";
import {TiTick} from "react-icons/ti";
import {MdDeleteForever} from "react-icons/md";
import {BiEditAlt,BiShowAlt} from "react-icons/bi"
import Spinner from "../../components/Spinner";
import Tooltip from '@mui/material/Tooltip';
const Sponsors = () => {
  const navigate=useNavigate();
  const dispatch=useDispatch();
  // ..............................................................useState............
  const {sponsors}=useSelector((state)=>state.sponsors);
  const[showmodal,setShowmodal]=useState(false); 
  const[showmodalD,setShowmodalD]=useState(false); 
  const [modalValue,setModalValue]=useState([]);
  const {user}=useSelector((state)=>state.auth)
  const {SisLoading,SisSucess,Smessage,SisError,Sreload}=useSelector((state)=>state.sponsors)
  // ..............................................................useEffect....................
  useEffect(()=>{
    dispatch(togglebars())
  })

  useEffect(()=>{
    if(user){
    dispatch(getSponsors())
    setShowmodalD(false)}
  },[Sreload,dispatch,user])
  useEffect(()=>{

    if(!user){
      dispatch(Sreset())
      navigate("/")
    }
    else if(SisError && Smessage){
      toast.error(Smessage)
    }
    return ()=>dispatch(Sreset())
  },[user,SisError,SisSucess,Smessage,navigate,dispatch] )
  // .........................................................MUI table settings......................
const columns = [
  { field: 'fullName', headerName: 'Name', width: 200},
  { field: 'email', headerName: 'Email', width: 200 },
  { field: 'organizationName', headerName: 'Organization', width: 130 },
  { field: 'paymentDone', headerName: 'Payment Status', width: 80 },
  {   field:'approved' , headerName: 'Approve ', with:250 , renderCell:(params)=>{
    return(<>
     <Tooltip title="Set approved Status">
      <button className='tikTackApprove' style={{color:params.row.approved.toString()==="true"?"green":"lightgray"}} onClick={()=>{
         const fdata=new FormData();
         const id=params.row._id;
         if(params.row.approved===true && (SisLoading===false || SisLoading==="")){
        fdata.append("approved", false)
        dispatch(updateSponsor({fdata,id}))
      }else if(params.row.approved===false && (SisLoading===false || SisLoading==="")){
        fdata.append("approved", true)
        dispatch(updateSponsor({fdata,id}))
      }

      }}><TiTick/></button>
      </Tooltip>
      <p>{params.row.approved.toString()}</p>
      </>
    )
} },
{   field:'UpdateWhole' , headerName: 'Information', with:100 , renderCell:(params)=>{
  return(
  <>
     <Tooltip title="Update info">
    <Link to={"/updatesponsor/"+params.row._id}  className='fullDetailtsBtn'><BiEditAlt/></Link>
    </Tooltip>
    <Tooltip title="See full info">
    <button className='fullDetailtsBtn' onClick={()=>modal(params.row)}><BiShowAlt/></button>
    </Tooltip>
    </>
  )
} },
{   field:'delete' , headerName: 'Delete', renderCell:(params)=>{
  return(
  <>
     <Tooltip title="Click to delete">
    <button onClick={()=>Dmodal(params.row)} style={{backgroundColor:"transparent",border:"none"}}><MdDeleteForever style={{color:"#e12121",backgroundColor:"transparent",fontSize:"1.4rem",marginLeft:"1rem "}}/></button>
    </Tooltip>
    </>
  )
} },
];
// .........................................................modal to see full info..................................
const modal=(obj)=>{
  setShowmodal(true)
  setModalValue(obj)
}
// .........................................................modal for delete warning....................................
const Dmodal=(obj)=>{
setShowmodalD(true)
setModalValue(obj)
}
// ........................................................spiiner if api is being called yet.................................

// ........................................................major return for attendee function...................................
  return (
  <div className='UserListParent'>
   {SisLoading?<Spinner/>:null}
    {sponsors? <>
   <div className='UserList'>
       <DataGrid
        rows={sponsors}
        columns={columns}
        pageSize={10}
        getRowId={(row) => row._id}
        rowsPerPageOptions={[10]}
        checkboxSelection
         disableSelectionOnClick/>
        </div>
        <Link to="/newSponsor" style={{backgroundColor:"#33285e",color:"white",textDecoration:"none"}} className='fullDetailtsBtn'>Add new Sponsor</Link>
        {/* ...............................................................modal for full info of attendeee.............................. */}
        {showmodal?<div className='attendeeModal'>
          <div className='attendeeModal-container'>
          <button onClick={()=>setShowmodal(false)}>Close</button>
          {modalValue?
          <div className='detailsAttendee' id="detailsAttendee" style={{gridTemplateColumns:"1fr 1fr",paddingTop:"10vh"}}>
            <p><span>fullName</span> :<span> {modalValue.fullName}</span></p>
            <p><span>email</span> :<span> {modalValue.email}</span></p>
            <p><span>organizationName</span> :<span> {modalValue.organizationName}</span></p>
            <p><span>amountPaid</span> :<span> {modalValue.amountPaid}</span></p>
            <p><span>approved</span> :<span> {modalValue.approved.toString()}</span></p>
            <p><span>paymentDone </span>: <span>{modalValue.paymentDone.toString()}</span></p>
            <p><span>paymentEmail </span>: <span>{modalValue.paymentEmail}</span></p>
            <p><span>paymentId </span>: <span>{modalValue.paymentId}</span></p>
            <p><span>paymentMethod </span>: <span>{modalValue.paymentMethod}</span></p>
            <p><span>createdAt</span> :<span> {modalValue.createdAt}</span></p>
            <p><span>updatedAt</span> :<span> {modalValue.updatedAt}</span></p>
            <p><span>_id </span>: <span>{modalValue._id}</span></p>
          </div>
          :null}</div>
          </div>:null}
          {/* ...........................................................modal for delete warning................. */}
          {showmodalD?<div className='attendeeModalD'>
          <div className='attendeeModal-containerD'>
          <button onClick={()=>setShowmodalD(false)}>Close</button>
          <center className="deleteConfirmation">
            <h1>Are you sure to delete this Sponsor</h1>
          {modalValue?
            <>
            <div>
            <p><span>fullName</span> :<span> {modalValue.fullName}</span></p>
            <p><span>email</span> :<span> {modalValue.email}</span></p>
            </div>
            <div>
              <button onClick={()=>{dispatch(deleteSponsor(modalValue._id))}}>Yes</button>
              <button onClick={()=>setShowmodalD(false)}>No</button>
            </div>
            </>
          :null}</center></div>
          </div>:null}
    </>:
null
  }
 </div> )
}

export default Sponsors;